var ApiCall = {
  PING: "Ping",
  PING_LEGACY: "ping",
  LOGIN: "LoginUser",
  LOGOUT: "LogoutUser",
  GET_MY_IP: "GetMyIP",
  ONLINE_RESET_USER_PASSWORD: "OnlineResetUserPassword",
  INVOKE_GET_METHOD: "InvokeGetMethod",
  INVOKE_METHOD: "InvokeMethod",
  VALIDATE_USER_SESSION: "ValidateUserSession",
  RACING_ACCESS_SVC: "useraccesssvc",
};

export default ApiCall;
